/**
 * A control of a viewer's floating bar (Figma "zoom toolbar"): an icon in a
 * 32px square. The zoom of an image or a PDF, the pages of a PDF, the fit,
 * full screen and the original's tab share one bar, so they share this look.
 *
 * `aria-disabled`, not `disabled`: a disabled button drops the focus to the
 * body, where the arrow keys of a viewer no longer reach it.
 */
export function ViewerToolbarButton({
  label,
  isDisabled,
  onClick,
  children,
}: {
  label: string;
  isDisabled: boolean;
  onClick: () => void;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      aria-disabled={isDisabled}
      onClick={() => {
        if (isDisabled) return;
        onClick();
      }}
      className="flex size-8 cursor-pointer items-center justify-center rounded-md border-none bg-transparent p-0 text-ds-black hover:bg-ds-slate-50 aria-disabled:cursor-not-allowed aria-disabled:opacity-40 [&>svg]:size-4"
    >
      {children}
    </button>
  );
}

/** The rule between two groups of a viewer's floating bar. */
export function ViewerToolbarDivider(): React.JSX.Element {
  return <span aria-hidden className="mx-1 h-5 w-px bg-ds-slate-100" />;
}
